<template>
  <div class="content-wrapper">
    <SendGiftMenu backTo="/card-message" />
    <Loading
      v-if="!loadStatus"
      text="Loading your recipients ..."
      style="margin-left: 0px;"
    />
    <div v-if="loadStatus">
      <RecipientOption :recipients="recipients" />
      <div v-if="showButtons" class="recipient-buttons">
        <button
          class="button-gemnote button-gemnote--medium"
          @click="confirmOrder"
        >
          Continue
        </button>
        <router-link
          :to="{ name: 'AddRecipient' }"
          tag="div"
          class="whitebutton-gemnote button-gemnote--medium"
          >New recipient</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { status, progressStatus, layouts, validateZipCode } from '../../helpers'
import SendGiftMenu from '@/components/SendGiftMenu'

export default {
  name: 'SelectRecipent',
  created() {
    this.$store.dispatch('recipient/loadRecipients')
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
  },
  components: {
    RecipientOption: () => import('@/components/SendGiftFlow/RecipientOption'),
    SendGiftMenu
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadRecipients)
    },
    // eslint-disable-next-line vue/return-in-computed-property
    showButtons() {
      switch (this.loadRecipients) {
        case status.INITIALIZED:
        case status.LOADING:
        case status.ERROR:
          return false
        case status.LOADED:
          return true
      }
    },
    ...mapState({
      loadRecipients: state => state.recipient.loadRecipients,
      errors: state => state.recipient.errors,
      recipients: state => state.recipient.recipients,
      recipientResourceType: state => state.order.recipientResourceType,
      salesForceRecipient: state => state.order.salesForceRecipient,
      selectedRecipientId: state => state.order.selectedRecipientId,
      shoppingBagProducts: state => state.order.shoppingBagProducts
    })
  },
  methods: {
    confirmOrder() {
      let errors = []
      if (!this.selectedRecipientId || this.selectedRecipientId === '') {
        errors.push('Please select a recipient to continue.')
      }

      if (!this.shoppingBagProducts.length) {
        errors.push('Please select a at least one product to continue.')
      }

      if (errors.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: errors
        })
        return
      }

      let orderData = {
        recipientId: this.selectedRecipientId,
        cardMessage: this.message
      }

      if (this.recipientResourceType === 'gemnoteUID') {
        this.$store.dispatch('order/createOrder', orderData)
      } else {
        // create recipient from salesforce and then place new order
        let { address } = this.salesForceRecipient
        if (address) {
          let formatedAddreess = this.salesForceRecipient.address.replace(
            '\n',
            ''
          )
          formatedAddreess = formatedAddreess.replace('\n', ' ')
          formatedAddreess = formatedAddreess.split(' ')

          let zipcode = formatedAddreess[formatedAddreess.length - 2]
          let state = formatedAddreess[formatedAddreess.length - 3]
          if (zipcode || state) {
            if (validateZipCode(zipcode)) {
              let recipientData = {
                name: this.salesForceRecipient.recipientName,
                email: this.salesForceRecipient.email,
                address_one: this.salesForceRecipient.address,
                city: '',
                state,
                zipcode,
                salesforce_resource_uid: this.salesForceRecipient.salesForceUI
              }
              this.$store.dispatch('recipient/addRecipient', recipientData)
            } else {
              errors.push(
                `Selected salesforce recipient, does not have a valid zipcode.`
              )
              this.$store.dispatch('notification/pushNotification', {
                type: 'error',
                messages: errors
              })
            }
          } else {
            errors.push(
              `There's no zipcode on selected recipient from salesforce, imposible create new recipient without zipcode, this property is required.`
            )

            if (errors.length) {
              this.$store.dispatch('notification/pushNotification', {
                type: 'error',
                messages: errors
              })
              return
            }
          }
        } else {
          errors.push(
            `There's no address on selected recipient from salesforce, this property is required.`
          )

          if (errors.length) {
            this.$store.dispatch('notification/pushNotification', {
              type: 'error',
              messages: errors
            })
            return
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.recipient-buttons {
  display: flex;
  flex-direction: column;

  button {
    margin-bottom: 1rem;
  }
}
</style>
